import React from "react";
import VideoGeneration from "../base/VideoGeneration";

export default function MissionVideo(props) {
  return <VideoGeneration {...props} />;
}
